import { Component, ViewChild, HostListener, OnInit, OnDestroy, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api';
import { Constant,SolrContentTypeValues,ManageTitle,ContentTypeValues,IsOpenNewTab, pageInfo, RedirectionPage } from 'src/app/common/constant/constant';
import { NgbModal, NgbModalConfig, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from 'src/app/components/common/confirmation/confirmation.component';
import { SubmitLoaderComponent } from 'src/app/components/common/submit-loader/submit-loader.component';
import { CommonService } from 'src/app/services/common/common.service';
import { Subscription } from "rxjs";
import * as moment from 'moment';
import { Table } from "primeng/table";
import { RepairOrderService } from 'src/app/services/repair-order/repair-order.service';
import { ThreadPostService } from 'src/app/services/thread-post/thread-post.service';
import { ApiService } from 'src/app/services/api/api.service';
import { ViewRoDetailComponent } from 'src/app/components/common/view-ro-detail/view-ro-detail.component';
import { Title } from "@angular/platform-browser";
import { LandingpageService } from 'src/app/services/landingpage/landingpage.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { SuccessModalComponent } from 'src/app/components/common/success-modal/success-modal.component';
import { ThreadService } from "src/app/services/thread/thread.service";
import { BaseService } from 'src/app/modules/base/base.service';
import { ExportPopupComponent } from 'src/app/components/common/export-popup/export-popup.component';
import { AssignedTechComponent } from '../../assigned-tech/assigned-tech/assigned-tech.component';

@Component({
  selector: 'app-sales-list',
  templateUrl: './sales-list.component.html',
  styleUrls: ['./sales-list.component.scss']
})
export class SalesListComponent implements OnInit {
  @ViewChild("top", { static: false }) top: ElementRef;
  @ViewChild("table", { static: false }) table: Table;
  @ViewChild('mapRef', {static: true }) mapElement: ElementRef;
  @Input() access:string = 'sales';
  @Input() cshopId: any = 0;
  @Input() salesData: any = [];
  @Input() salesPageData: any = []; 
  @Input() searchValue: any = '';
  @Input() accessFrom: any = pageInfo.roPage;
  @Input() isDistributorId: any = 0;
  @Output() salesListComponentRef: EventEmitter<SalesListComponent> = new EventEmitter();
  @Output() salesListPageCallback: EventEmitter<SalesListComponent> = new EventEmitter();
  @Output() salesIndexListComponentRef: EventEmitter<SalesListComponent> = new EventEmitter();
  @Output() callbackSales: EventEmitter<SalesListComponent> = new EventEmitter();
  @Output() searchResultData: EventEmitter<any> = new EventEmitter();
  @Output() salesCallback: EventEmitter<SalesListComponent> = new EventEmitter();

  public pushRoArrayNotification=[];  
  public sconfig: PerfectScrollbarConfigInterface = {};
  subscription: Subscription = new Subscription();
  public baseUrl: string = "repair-order";
  public pageUrl: string = `${this.baseUrl}`;
  public setInterval: any;
  public filterSelected: boolean = false;
  public accessLevel : any = {view: true, create: true, edit: true, delete:true};
  public searchPage: any = pageInfo.searchPage;
  public redirectionPage='';
  public paaitleText='';
  public apiKey: string = Constant.ApiKey;
  public fromSearch = "";
  public filterOptions: any = [];
  public attachmentLoading: boolean = true;
  public attachmentsData: any;
  public action = "view";
  public approvedFlag=0;
  public editThreadId='';
  public assetPath: string = "assets/images/";
  public assetShopPath: string = `${this.assetPath}shop`;
  public assetPartPath: string = `${this.assetPath}parts`;
  public redirectUrl: string = "shop/view/";
  public defShopBanner: string = `${this.assetPath}common/default-shop-banner.png`;
  public scanReport: boolean = false;
  public collabticDomain: boolean = false;
  public showBestMatchAllowDomain: boolean = false;
  public editAccess: boolean;
  public selectedItem: any = 0;
  public displayNoRecords: boolean = false;
  public displayNoRecordsDefault: boolean = false;
  public popupView: boolean = false;
  public expandFlag: boolean;
  public shopApiCall;
  public shopWsApiCall;
  public shopType: string = "";
  public publishStatus: string = "";
  public searchVal: string = "";
  public itemLimit: any = 20;
  public itemOffset: any = 0;
  public userId;
  public user;
  public domainId;
  public roleId;
  public businessRoleId;
  public businessId;
  public endUser: boolean = false;
  public salesPerson: boolean = false;
  public isDistributor: boolean = false;
  public techUser: boolean = false;
  public mobileTechUser: boolean = false;
  public techSupportSettings: any = 0;
  public mobileTechSupportSettings: any = 0;
  public countryId='';
  public platformId: string;
  public apiData: Object;
  public serviceError: boolean = false;
  public serviceErrorMsg: string = '';
  public bodyHeight: number;
  public innerHeight: number;
  public emptyHeight: number;
  public tableRemoveHeight: number = 160;

  public groupId: number = 6;
  public displayNoRecordsShow = 0;
  public itemEmpty: boolean;
  public thumbView: boolean = true;
  public itemLength: number = 0;
  public itemTotal: number = 0;
  public itemList: object;
  public itemResponse = [];
  public shopSelectionList = [];
  public pinImg: string;
  public pinStatus: number;
  public likeCount: number;
  public pinCount: number;
  public pinTxt: string;
  public navAction: string = "single";
  public shortTitle: string = "RO";
  public roTitle: string = "";
  public contentType: any = ContentTypeValues.Sales;
  public contentTypeValue;
  public contentTypeDefaultNewImg;
  public contentTypeDefaultNewText;
  public contentTypeDefaultNewTextDisabled: boolean = false;
  public shopUrl='';
  public newPartInfo: string = "Get started by tapping on ‘New’.";
  public chevronImg: string = `${this.assetPartPath}chevron.png`;
  public headercheckDisplay: string = "checkbox-hide";
  public headerCheck: string = "unchecked";
  public priorityIndexValue='';
  public shopIdArrayInfo: any=[];
  public shopAPICount: any="0";
  public searchnorecordflag: boolean = true;
  public searchLoading: boolean = true;
  public filterrecords : boolean = false;
  public actionType: string = '';
  public filterStatusList: any = [];
  public filterBustinessList: any = [];
  public filterAssignedTechList: any = [];
  public salesFilterValues: any = [];
  public activeFilters: any = [];

  public loading: boolean = false;
  public lazyLoading: boolean = false;
  public scrollInit: number = 0;
  public lastScrollTop: number = 0;
  public scrollTop: number;
  public scrollCallback: boolean = true;
  public opacityFlag: boolean = false;

  salesListColumns: any = [];
  repairOrderList: any = [];
  public pageAccess: string = "repairorder";
  public successFlag: boolean = false;
  public successMsg: string = "";
  public visibilityChangeLimit=0;
  public visibilityChange: boolean = false;
  public showMap: any = false;
 
  public listView: boolean = false;
  public jobcodeArr: string = '';
  public odometerFlag: boolean = false;
  public problemDescFlag: boolean = false;
  public errroMsgFlag: boolean = false;

  public readOnlyFlag: boolean = false;
  public ordernumberReadOnlyFlag: boolean = false;
  public dninvoiceReadOnlyFlag: boolean = false;
  public productservicesReadOnlyFlag: boolean = false;
  public completedListFlag: boolean = false;
  public invoicedListFlag: boolean = false;
  public paidListFlag: boolean = false;
  public deletedListFlag: boolean = false;
  public noSupportListFlag: boolean = false;
  public statusFilterDisabled: boolean = false;
  public responseData = {
    displayNoRecords: this.displayNoRecords,
    displayNoRecordsDefault: this.displayNoRecordsDefault,
    headercheckDisplay: this.headercheckDisplay,
    headerCheck: this.headerCheck,
    itemEmpty: false,
    loading: this.loading,
    action: false,
    repairOrderList: this.repairOrderList,
    itemOffset: this.itemOffset,
    itemTotal: this.itemTotal,
    searchVal: this.searchVal,
    headerAction: false,
    filterrecords: this.filterrecords,
  };
  public modalConfig: any = {
    backdrop: "static",
    keyboard: false,
    centered: true,
  };

  public tvsDomain: boolean = false;
  public searchAction: boolean = false;
  public bodyElem;
  
  public sortorderEvent;
  public sortFieldEvent;
  public dataFilterEvent;
  public dataFilterObj: any = '';
  public sortFilterapplied: boolean = false;
  public searchFilterapplied: boolean = false;
  public scrollLeftevt: number = 0;


  public mediaConfig: any = {backdrop: 'static', keyboard: false, centered: true, windowClass: 'attachment-modal'}

  public bussContact: string = '';
  public bussCustomer: string = '';
  public contactTechnician: string = '';
  public bodyClass2: string = "submit-loader";
  public bodyClass:string = "auth-index";
  public editRO: boolean = false;
  public workOrderType: string = 'new';
  public workOrderId: string = '';
  public viewOptions: any = [];
  public view: any = '';
  public platform: any = 3;
  public fuserDomain: boolean = false;
  public diagnationDomain: boolean = false;
  public aetoolsDomain: boolean = false;
  public initcomplaint: string = '';
  public billingfirstname: string = '';
  public billinglastname: string = '';

  public cols = [];
  public headTitle: string = '';

  public startDate: any = '';
  public endDate: any = '';

  public saveObjData:any='';
  public gbbDomain: boolean = false;
  public selectedColumns: any = [];
  public selectColOptions: any = [];
  
  // Resize Widow
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.bodyHeight = window.innerHeight;    
    this.setScreenHeight();

    setTimeout(() => {
      if (!this.displayNoRecords) {
        let listItemHeight;
        listItemHeight = document.getElementsByClassName("parts-mat-table")[0] == undefined ? '' :
        document.getElementsByClassName("parts-mat-table")[0].clientHeight + 50;  
        console.log(this.itemTotal, this.itemLength,  this.innerHeight, listItemHeight);  
        if(this.itemTotal > this.itemLength && this.innerHeight >= listItemHeight) {
          this.scrollCallback = false;
          this.lazyLoading = true;
          this.getSalesList(false);
          this.lastScrollTop = this.scrollTop;
        } 
      }
    }, 1500);
  }

  // Scroll Down
  @HostListener("scroll", ["$event"])
  onScroll(event: any) {
    if(!this.popupView) {
      this.scroll(event);
    }
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private commonApi: CommonService,
    public acticveModal: NgbActiveModal,
    private modalService: NgbModal,
    private config: NgbModalConfig,
    public apiUrl: ApiService,
    private repairOrderApi: RepairOrderService,
    private threadPostService: ThreadPostService,
    private titleService: Title,
    private LandingpagewidgetsAPI: LandingpageService,
    private authenticationService: AuthenticationService,
    private baseSerivce: BaseService,
  ) {
    config.backdrop = "static";
    config.keyboard = false;
    config.size = "dialog-centered";

    document.addEventListener('visibilitychange', () => {
      if(this.access == 'sales'){ 
        if (document.hidden) {
          // do whatever you want
          console.log('Hidden');
        }
        else {
          // do whatever you want
          console.log('Show thread');
          let mynewthread=localStorage.getItem('mynewthread');
          this.visibilityChange = true;
          this.visibilityChangeLimit=3;        
          setTimeout(() => {
            this.getSalesList(false);  
          }, 500);          
        }
      }
    });
  }

  ngOnInit(): void {
    window.addEventListener('scroll', this.scroll, true);
    this.bodyElem = document.getElementsByTagName('body')[0];
    this.bodyElem.classList.add("repairorderlist");
    this.bodyElem.classList.add(this.bodyClass);
    localStorage.setItem('currentContentType', '75');
    if(this.access == 'sales' || this.access == 'financials-list'){      
      this.salesIndexListComponentRef.emit(this);
    }   

    if(this.access == 'customers' || this.accessFrom == pageInfo.workstreamPage || this.accessFrom == pageInfo.searchPage){      
      this.salesListComponentRef.emit(this);
    }  

    this.route.params.subscribe( params => {
      this.isDistributorId = parseInt(params.shopId);
      if(this.isDistributorId > 0) {
        this.displayNoRecordsShow = 1;
      }
    });

    this.bodyHeight = window.innerHeight;
    this.platformId = localStorage.getItem('platformId');
    this.collabticDomain = (this.platformId=='1') ? true : false;
    let platformId: any = localStorage.getItem('platformId');
    //this.showBestMatchAllowDomain =  (platformId == PlatFormType.Collabtic) ||  (platformId == PlatFormType.CbaForum) ? true : false;
    this.showBestMatchAllowDomain = this.apiUrl.showBestMatchAllowDomain;
    this.setScreenHeight();
    this.checkAccessLevel();
    setTimeout(() => {      
      this.setScreenHeight();
    }, 1000);    
    console.log(this.bodyHeight, this.access);

    this.access = this.salesPageData.roaccess;
    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;
    this.userId = this.user.Userid;
    this.roleId = this.user.roleId;

    let businessRole = localStorage.getItem('businessRole');
    this.businessRoleId = (businessRole) ? businessRole : 0;
    let businessId = localStorage.getItem('businessId');
    this.businessId = (businessId) ? parseInt(businessId) : 0;
    let techSupportSettings = localStorage.getItem('techSupportSettings');
    this.techSupportSettings = (techSupportSettings) ? techSupportSettings : 0;
    let mobileTechSupportSettings = localStorage.getItem('mobileTechSupportSettings');
    this.mobileTechSupportSettings = (mobileTechSupportSettings) ? mobileTechSupportSettings : 0;
    this.apiKey = this.salesPageData.apiKey;
    this.countryId = this.salesPageData.countryId;
    this.completedListFlag = this.salesPageData.completedListFlag;
    this.invoicedListFlag = this.salesPageData.invoicedListFlag;
    this.paidListFlag = this.salesPageData.paidListFlag;
    this.deletedListFlag = this.salesPageData.deletedListFlag;   

    this.fuserDomain = this.domainId == '343' ? true : false;
    this.diagnationDomain = this.domainId == '338' ? true : false;
    this.aetoolsDomain = this.domainId == '411' ? true : false;
    this.gbbDomain = this.domainId == '462' || this.domainId == '511' ? true : false;

    this.endUser = (this.roleId == 4) ? true : false;
    this.techUser = (this.roleId != 3 && this.businessRoleId == 6) ? true : false;
    this.salesPerson = (this.roleId != 3 && this.businessId == 13) ? true : false;
    let isMobileTech = parseInt(localStorage.getItem('isMobileTech'));
    this.mobileTechUser = (this.roleId != 3 && isMobileTech == 1) ? true : false;
    let industryType = this.commonApi.getIndustryType();
    this.headTitle = "";
    this.headTitle = (industryType.id == 3 && this.domainId == '97') ? ManageTitle.feedback : ManageTitle.thread;
    let platformId1 = localStorage.getItem("platformId");
    this.headTitle = ManageTitle.sales;    
    let paramTimeout = (this.accessFrom == pageInfo.workstreamPage || this.accessFrom == pageInfo.searchPage) ? 1000 : 0;

    if(this.accessFrom == pageInfo.workstreamPage) {
      setTimeout(() => {
        this.getSalesList(false);  
      }, 1500);      
    }

    this.subscription.add(
      this.commonApi.emitNotificationDataSubject.subscribe((data) => {
        console.log(data);
        this.showNotificationData(data);
      })
    );

    this.subscription.add(
    this.shopApiCall = this.commonApi.updateRODataReceivedSubject.subscribe((data) => {
      switch(data['action']){
        case 'refresh':
          this.workOrderType = data['action'];
          this.workOrderId = data['id'];
          setTimeout(() => {
          this.getSalesList(true);  
          }, 1500);            
        break;
        case 'edit':
          this.openRepairOrderPOPUP('edit',data['id']);
        break;
        default:
        break;
      }
    }));

    this.subscription.add(
      this.commonApi.NewButtonHeaderCallReceivedSubject.subscribe((r) => {
        if(r == 'repairorder'){
          let id = '';
          this.openRepairOrderPOPUP('new',id);
        }
      })
    );  
  }

  showNotificationData(data,background=0) {
    console.log(data+'check for complete');
    let pushType = (data['pushType'] && data['pushType'] != undefined && data['pushType'] != '') ? parseInt(data['pushType']) : 0;
    if(pushType == 61) {
      let workOrderId = data['dataId'];
      this.itemLimit = 1;
      this.itemOffset = 0;
      setTimeout(() => {
        this.getSalesList(true,'',workOrderId);
      }, 500);
    }    
  }
  @HostListener('document:visibilitychange', ['$event'])

  visibilitychange() {
    console.log('PushCheck');    
    //let type1=0;
    let type1=1;
    navigator.serviceWorker.addEventListener('message', (event) => {
      let roInfo=event.data.data;
      console.log(roInfo)
      let pushType = (roInfo.pushType && roInfo.pushType != undefined && roInfo.pushType != '') ? parseInt(roInfo.pushType) : 0;
      if(pushType == 61) {
        if(this.pushRoArrayNotification.length==0) {
          console.log(roInfo);
          let backgroundPush=1;
          this.showNotificationData(roInfo,backgroundPush);
          setTimeout(() => {
            this.pushRoArrayNotification=[];
          }, 1000);
        }
        this.pushRoArrayNotification.push(roInfo.dataId);
      }      
    });
  }

  sortPage(event : LazyLoadEvent) {
    /*console.log(event);
    console.log(event?.sortField);
    console.log(event?.sortOrder);*/
    this.sortFieldEvent = event.sortField;
    this.sortorderEvent = event.sortOrder;
    this.dataFilterEvent = event.filters;
    let conditionText = '';
    let value = '';
    let obj: any = [];
    this.searchFilterapplied = false; 
    //console.log(this.dataFilterEvent)
    let searchFlag: any = false;
    Object.keys(event).forEach(function(key) {
      let eventKey = event[key];
      switch(key) {
        case 'filters':
          Object.keys(eventKey).forEach(item => {
            let filterInfo = eventKey[item];
            //console.log(filterInfo);
            value = filterInfo[0].value;
            let matchMode = filterInfo[0].matchMode;
            if(value != null) {
              searchFlag = true;
              switch(matchMode) {
                case "startsWith":
                  conditionText = "starts_with";
                break;
                case "endsWith":
                  conditionText = "ends_with";
                break;
                case "contains":
                  conditionText = "matches";
                break;
                case "notContains":
                  conditionText = "notmatches";
                break;
                case "notContains":
                  conditionText = "notmatches";
                break;
                case "equals":
                  conditionText = "matches";
                break;
                case "notEquals":
                  conditionText = "notmatches";
                break;
              }  
              obj[item]={"condition": conditionText, "value": value };
            }
          }) 
          break;
      }
    });
    //console.log(obj)
    this.searchFilterapplied = searchFlag;
    this.dataFilterObj = obj;
    this.getSalesListIndex();
  }

  getSalesListIndex(){ 
    this.itemLimit = 20;  
    this.itemOffset = 0;
    this.itemLength = 0;
    this.itemTotal = 0;
    this.lastScrollTop = -1 ;
    this.visibilityChangeLimit=0;  
    this.repairOrderList = [];
    this.workOrderType = '';
    this.getSalesList(false);
  }

  // Get Filter Values
  getFilterValues() {
    let completed = (this.completedListFlag || this.invoicedListFlag || this.paidListFlag) ? 1 : 0;
    let invoiced = (this.invoicedListFlag) ? 1 : 0;
    let deleted  = (this.deletedListFlag) ? 1 : 0;
    let solrFilter = {'domainId': this.domainId, completeStatusInt: completed, invoicedInt: invoiced, deleteStatusInt: deleted};

    if (this.access == 'financials-list') {
      delete solrFilter.completeStatusInt;
    }
    let statusFilterFlag = (this.completedListFlag || this.invoicedListFlag || this.paidListFlag || this.deletedListFlag) ? false : true;
    this.statusFilterDisabled = !statusFilterFlag;    
    let checkTypeList = (this.activeFilters.length > 0) ? this.activeFilters : ''; 
    let checkActiveList = [];
    if(checkTypeList) {
      checkTypeList.forEach((item, index) => {
        if(index > 0) {
          checkActiveList.push(item);
        }
      });
    }
    let checkType = ''; 
    let checkTypeIndex: any;
    let statusFlag = true;
    let techFlag = true;
    let businessFlag = true;
    let roFilterLength = this.salesFilterValues.length;
    console.log(checkActiveList, roFilterLength, this.activeFilters)
    console.log(this.salesFilterValues)
    this.salesFilterValues.forEach(roItem => {
      let value = roItem.value;
      let type = roItem.type;
      checkTypeIndex = this.activeFilters.findIndex(option => option == type);
      if(checkTypeIndex >= 0) {
        checkType = this.activeFilters[checkTypeIndex];
      } 
      switch(type) {
        case 'business':
          solrFilter["roBusinessName"] = [value];
          if(type == checkType && roFilterLength <= 3) {
            businessFlag = false;
          }
          break;
        case 'assign-tech':
          solrFilter["assignTechnicianIdInfoStr"] = [value];
          if(type == checkType && roFilterLength <= 3) {
            techFlag = false;
          }
          break;
        case 'status':
          if(statusFilterFlag) {
            solrFilter["workOrderStatusStr"] = [value];
          }
          if(statusFilterFlag || (type == checkType && roFilterLength <= 3)) {
            statusFlag = false;
          }
          break;
      }
    });

    let solrData = {
      type: 7,
      filters: solrFilter
    }
    let apiAccess = '';
    this.commonApi.getSolrFilterList(solrData, apiAccess).subscribe((response) => {
      let filterData = response.facets;
      if(statusFlag) {
        this.filterStatusList = [];
        let roStatus = filterData.workOrderStatusInfoJsonArr;
        roStatus.forEach(sitem => {
          let svalue = JSON.parse(sitem.value);
          if(this.domainId == 507) {
            switch(svalue.id) {
              case 1:
                sitem.statusName = (this.endUser) ? 'RO Sent' : sitem.statusName;
                break;
              case 12:
                sitem.statusName = (this.endUser) ? 'Invoice' : sitem.statusName;
                break;
              case 14:
                sitem.statusName = (this.endUser) ? 'Estimate' : sitem.statusName;
                break;              
            }            
          }          
          this.filterStatusList.push({id: parseInt(svalue.id), name: svalue.statusName});
        });
        if(!this.endUser && !this.completedListFlag && !this.paidListFlag && (this.domainId == 63 || this.domainId == 397 || this.domainId == 346 || this.domainId == 432 || this.domainId == 462)) {
          this.filterStatusList.push({id: 12, name: 'Invoice Sent'});
        }
      }
      
      if(techFlag) {
        this.filterAssignedTechList = [];
        let assignedTech = filterData.assignTechnicanInfoJsonArr;
        assignedTech.forEach(aitem => {
          let avalue = JSON.parse(aitem.value);
          let name = `${avalue.firstName} ${avalue.lastName}`;
          this.filterAssignedTechList.push({id: parseInt(avalue.userId), name});
        });
      }

      if(businessFlag) {
        this.filterBustinessList = [];
        let businessList = filterData.roBusinessName;
        console.log(businessList)
        businessList.forEach(aitem => {
          let avalue = aitem.value;
          this.filterBustinessList.push({id: avalue, name: avalue});
        });
      }

      if(this.access == 'customers' || this.accessFrom == pageInfo.workstreamPage || this.accessFrom == pageInfo.searchPage) {
        this.salesCallback.emit(this);
      }
      else{
        this.callbackSales.emit(this);
      }
      
      if(checkTypeList && roFilterLength>1) {
        this.getFilterValuesCallback(checkActiveList);
      }     
    });
  }

  getFilterValuesCallback(checkActiveList) {
    let statusFlag = false;
    let techFlag = false;
    let businessFlag = false;
    let completed = (this.completedListFlag || this.invoicedListFlag || this.paidListFlag) ? 1 : 0;
    let invoiced = (this.invoicedListFlag) ? 1 : 0;
    let deleted  = (this.deletedListFlag) ? 1 : 0;
    let solrFilter = {'domainId': this.domainId, completeStatusInt: completed, invoicedInt: invoiced, deleteStatusInt: deleted};
    if (this.access == 'financials-list') {
      delete solrFilter.completeStatusInt;
    }
    if(this.paidListFlag) {
      solrFilter['workOrderStatusStr'] = ["13"];
    } else {
      /* if(!this.diagnationDomain) {
        solrFilter['workOrderStatusStr'] = ["7", "12"];
      } */
    }
    let rfi, cfi; 
    this.activeFilters.forEach(roItem => {
      //let value = roItem.value;
      let type = roItem;
      let checkType,value;
      console.log(type,checkType);
      switch(type) {
        case 'business':
          businessFlag = true;
          cfi = checkActiveList.findIndex(option => option == type);
          console.log(cfi)
          if(cfi >= 0) {
            rfi = this.salesFilterValues.findIndex(option => option.type == type);
            if(rfi >= 0) {
              businessFlag = (cfi < 1 && checkActiveList.length > 1) ? true : false; 
              value = this.salesFilterValues[rfi].value;
              solrFilter["roBusinessName"] = [value];
            }
          }
          break;
        case 'assign-tech':
          techFlag = true;
          cfi = checkActiveList.findIndex(option => option == type);
          console.log(cfi)
          if(cfi >= 0) {
            rfi = this.salesFilterValues.findIndex(option => option.type == type);
            if(rfi >= 0) {
              techFlag = (cfi < 1 && checkActiveList.length > 1) ? true : false; ; 
              value = this.salesFilterValues[rfi].value;
              solrFilter["assignTechnicianIdInfoStr"] = [value];
            }
          }
          break;
        case 'status':
          statusFlag = true;
          cfi = checkActiveList.findIndex(option => option == type);
          if(cfi >= 0) {
            rfi = this.salesFilterValues.findIndex(option => option.type == type);
            if(rfi >= 0) {
              statusFlag = (cfi < 1 && checkActiveList.length > 1) ? true : false; ;
              value = this.salesFilterValues[rfi].value;
              solrFilter["workOrderStatusStr"] = [value];
            }
          }
          break;
      }
    });
    let solrData = {
      type: 7,
      filters: solrFilter
    }
    let apiAccess = '';
    this.commonApi.getSolrFilterList(solrData, apiAccess).subscribe((response) => {
      let filterData = response.facets;
      if(statusFlag) {
        this.filterStatusList = [];
        let roStatus = filterData.workOrderStatusInfoJsonArr;
        roStatus.forEach(sitem => {
          let svalue = JSON.parse(sitem.value);
          if(this.domainId == 507) {
            switch(svalue.id) {
              case 1:
                sitem.statusName = (this.endUser) ? 'RO Sent' : sitem.statusName;
                break;
              case 12:
                sitem.statusName = (this.endUser) ? 'Invoice' : sitem.statusName;
                break;
              case 14:
                sitem.statusName = (this.endUser) ? 'Estimate' : sitem.statusName;
                break;              
            }
          }
          this.filterStatusList.push({id: parseInt(svalue.id), name: svalue.statusName});
        });
      }
      
      if(techFlag) {
        this.filterAssignedTechList = [];
        let assignedTech = filterData.assignTechnicanInfoJsonArr;
        assignedTech.forEach(aitem => {
          let avalue = JSON.parse(aitem.value);
          this.filterAssignedTechList.push({id: parseInt(avalue.userId), name: avalue.userName});
        });
      }

      if(businessFlag) {
        this.filterBustinessList = [];
        let businessList = filterData.roBusinessName;
        console.log(businessList)
        businessList.forEach(aitem => {
          let avalue = aitem.value;
          this.filterBustinessList.push({id: avalue, name: avalue});
        });
      }

      if(this.access == 'customers' || this.accessFrom == pageInfo.workstreamPage || this.accessFrom == pageInfo.searchPage) {
        this.salesCallback.emit(this);
      }
      else{
        this.callbackSales.emit(this);
      }      
    });
  }
  
  updateSearchKeyword(keyword) {
    const apiFormData = new FormData();
    apiFormData.append("apiKey", Constant.ApiKey);
    apiFormData.append("domainId", this.domainId);
    apiFormData.append("keyword", keyword);
    apiFormData.append("userId", this.userId);
    this.LandingpagewidgetsAPI.apiUpdateSearchKeyword(apiFormData).subscribe((response) => {});
  }

  // Get Sales List
  getSalesList(pushFlag, limit:any = '',roIdFromPush='',id = 0, updateFlag = false) {
    if(!this.visibilityChange){
      this.filterSelected = false;
    }
    let searchValue = '';
    let searchFlag = (this.searchValue && this.searchValue!='') ? true : false;
    let completedFlag = false;
   if(this.searchValue && this.searchValue!='')
   {
    searchValue=this.searchValue;
   }
    let type = (searchFlag) ? 'search' : 'list';

    this.scrollTop = 0;
    this.lastScrollTop = this.scrollTop;

    var objData = {};    
    let FiltersArr={};
    
    this.salesFilterValues.forEach(roItem => {
      let value = roItem.value;
      let ftype = roItem.type;
      switch(ftype) {
        case 'business':
          //FiltersArr["roBusinessName"] = [value];
          FiltersArr["roBusinessName"] = value;
          if(value){this.filterSelected = true;}
          break;
        case 'assign-tech':
          FiltersArr["assignTechnicianIdInfoStr"] = [value];
          if(value){this.filterSelected = true;}
          break;
        case 'status':
          FiltersArr["workOrderStatusStr"] = [value];
          if(value){
            this.filterSelected = true;
            if(parseInt(value) == 12) {
              FiltersArr["invoicedInt"] = 1;
              completedFlag = true;
            }
          }
          break;    
      }
    });

    console.log(pushFlag, limit, roIdFromPush)

    if(this.roleId != 3 && this.businessRoleId == 6 && this.techSupportSettings == 1) {
      //FiltersArr["assignTechnicianIdInfoStr"] = [this.userId];
    }
    let shoplistArr=localStorage.getItem('shoplistArr');
    if(shoplistArr)
    {
      let shopArrFilter=JSON.parse(shoplistArr);
      if(shopArrFilter && shopArrFilter.length>0)
        {
          FiltersArr["shopIdInt"] = shopArrFilter;
        }
    }
    if(id > 0) {
      FiltersArr["roIdInt"] = id;
    }
    if(this.endUser) {
      if(this.businessId == 0) {
        FiltersArr["shopIdInt"] = [this.businessId];
      }
      if(this.isDistributor && this.isDistributorId > 0) {
        let distributerId = [this.isDistributorId];
        FiltersArr["assignTechnicianIdInfoStr"] = distributerId;
      }
    } else {
        if(this.isDistributorId > 0) {
          let distributerId = [this.isDistributorId];
          FiltersArr["assignTechnicianIdInfoStr"] = distributerId;
        }
    }
    if((this.techUser && this.techSupportSettings == 1) || (this.mobileTechUser && this.mobileTechSupportSettings == 1) || this.salesPerson) {
      FiltersArr["assignTechnicianIdInfoStr"] = this.userId.toString();
    }
    let wsArr:any = [];

    if(this.accessFrom == pageInfo.searchPage) {
      let userWorkstreams=localStorage.getItem('userWorkstreams');
      if(userWorkstreams)
      {
        wsArr = JSON.parse(userWorkstreams);
        FiltersArr["workstreamsIds"] = wsArr;
      }
    }
    if(this.accessFrom == pageInfo.workstreamPage) {      
      let landingWorkstream = localStorage.getItem('workstreamItem');
      wsArr.push(landingWorkstream);
      FiltersArr['workstreamsIds'] = wsArr;
    }
    if(this.accessFrom == pageInfo.workstreamPage || this.accessFrom == pageInfo.searchPage) {    

      if(this.itemOffset == 0 && searchFlag){
      let apiDatasocial = new FormData();
      apiDatasocial.append('apiKey', Constant.ApiKey);
      apiDatasocial.append('domainId', this.domainId);
      apiDatasocial.append('workstreamIds', JSON.stringify(wsArr));
      apiDatasocial.append('userId', this.userId);
      apiDatasocial.append('contentTypeId', '50');

      this.baseSerivce.postFormData("forum", "resetWorkstreamContentTypeCount", apiDatasocial).subscribe((response: any) => { })
      }

    }
    if(this.access == 'customers') {
      FiltersArr["shopIdInt"] = [this.cshopId];
    } 
    
    if(this.completedListFlag || this.paidListFlag || this.invoicedListFlag){
      FiltersArr["completeStatusInt"] = 1;
      if (this.access == 'financials-list') {
        delete FiltersArr["completeStatusInt"];
      }
      if(!this.diagnationDomain) {
        //FiltersArr["workOrderStatusStr"] = ["7"];
      }
      this.filterSelected = true;
    }
    if(this.paidListFlag) {
      FiltersArr["workOrderStatusStr"] = ["13"];
      this.filterSelected = true;
    }
    if(this.deletedListFlag){
      FiltersArr["deleteStatusInt"] = 1;
      this.filterSelected = true;
    }
    if(this.invoicedListFlag) {
      FiltersArr["invoicedInt"] = 1;
      FiltersArr["workOrderStatusStr"] = ["12"];
    }
    if(this.completedListFlag) {
      //FiltersArr["invoicedInt"] = 0;
      FiltersArr["workOrderStatusStr"] = ["7", "12"];
    }

    if(pushFlag) {
      this.filterSelected = true;
      if(this.workOrderType == 'edit' || this.workOrderType == 'refresh'){
        FiltersArr["roIdInt"]=this.workOrderId;
        objData["rows"]=1; 
        objData["start"]=0;
      }
      else if(roIdFromPush)
      {
        //formData.append('id', roIdFromPush); 
        FiltersArr["roIdInt"]=roIdFromPush;
        objData["rows"]=1; 
        objData["start"]=0;
      }
      else{
        objData["rows"]=1; 
        objData["start"]=0;
        if(!this.completedListFlag && !this.invoicedListFlag && !this.paidListFlag && !this.deletedListFlag && !this.noSupportListFlag){
          if(!searchFlag && this.access != 'customers'){ 
            FiltersArr["completeStatusInt"] = (completedFlag) ? 1 : 0;
            if (this.access == 'financials-list') {
              delete FiltersArr["completeStatusInt"];
            } 
          }
          FiltersArr["deleteStatusInt"] = 0;
        }
      }
    }
    else if(this.visibilityChangeLimit==3)
    {
      //this.filterSelected = true;
      objData["rows"]=this.visibilityChangeLimit; 
      objData["start"]=0;
      if(!this.completedListFlag && !this.invoicedListFlag && !this.paidListFlag && !this.deletedListFlag && !this.noSupportListFlag && !pushFlag){
        if(!searchFlag && this.access != 'customers'){ 
          FiltersArr["completeStatusInt"] = (completedFlag) ? 1 : 0;
          if (this.access == 'financials-list') {
            delete FiltersArr["completeStatusInt"];
          } 
        }
        FiltersArr["deleteStatusInt"] = 0;
      }
    }
    else{
      objData["rows"]=this.itemLimit; 
      objData["start"]=this.itemOffset;
      if(!this.completedListFlag && !this.invoicedListFlag && !this.paidListFlag && !this.deletedListFlag && !this.noSupportListFlag && !pushFlag){
        //FiltersArr["workOrderStatusStr"] = ["1","2","3","4","8","9","10","12","13","14","15"];
        if(!searchFlag && this.access != 'customers'){ 
          FiltersArr["completeStatusInt"] = (completedFlag) ? 1 : 0;
          if (this.access == 'financials-list') {
            delete FiltersArr["completeStatusInt"];
          }
        }
        FiltersArr["deleteStatusInt"] = 0;
      }
    }

    let filterDates = [];
    if(this.startDate != '' && this.startDate != undefined && this.startDate != null  && this.endDate != '' && this.endDate != undefined && this.endDate != null){
      filterDates = [{ "field": "createdOnNew", "value1": this.startDate, "value2": this.endDate, "operator": "<>" }];
      objData["filterDates"] = filterDates;
      this.filterSelected = true;
    }

    if(this.sortFieldEvent != '' && this.sortFieldEvent != undefined && this.sortFieldEvent != null){
      objData["sortField"] = this.sortFieldEvent; 
      objData["sortOrder"] = this.sortorderEvent == 1 ? 'asc' : 'desc';   
      this.sortFilterapplied = true;
      this.filterSelected = true;
    }
    if(this.searchFilterapplied){       
      objData["filterSearch"] = ((Object.assign({}, this.dataFilterObj)));
      this.filterSelected = true;
    }
    
    if(searchFlag) {
      this.filterSelected = true;
      objData['query'] = searchValue;
    }
    if(this.endUser) {
     // FiltersArr['userIdInt'] = this.userId;
    }
    FiltersArr["approvalProcess"]="1";
    FiltersArr["domainId"]=this.domainId;
    FiltersArr["isEventTypeInt"] = 2;
    objData["type"]=SolrContentTypeValues.repairOrder;    
    objData["listing"] = searchFlag ? 0 : 1;
    objData["filters"]=FiltersArr;

    let uuIdData=localStorage.getItem('uuIdData');
    if(uuIdData)
    {
      objData["uuid"]=uuIdData;
      objData["userId"]=this.userId;
      objData["platform"]=3;

    }

    if(this.showBestMatchAllowDomain && objData["query"] != '')
    {
      objData["exactMatch"] = this.apiUrl.exactMatch;
    }

    if(this.itemOffset == 0 && searchFlag)
      {
        this.updateSearchKeyword(searchValue);
      }
    if(searchFlag){
        if(FiltersArr["make"]){
         objData["make"] = FiltersArr["make"]
        } 
        if(FiltersArr["model"]){
          objData["model"] = FiltersArr["model"]
        }     
        if(FiltersArr["year"]){
          objData["year"] = FiltersArr["year"]
        } 
        objData['userName'] = this.user?.Username;
        objData['userEmail'] = this.user?.Email;
        if(this.apiUrl.subscriptionInfo?.product_name) {
          objData['subscriptionType'] = this.apiUrl.subscriptionInfo?.product_name;
        }
      }
     
    this.saveObjData = pushFlag == false && this.itemOffset == 0 && this.visibilityChangeLimit==0 ? objData : this.saveObjData;
    console.log(objData);
    console.log(this.saveObjData);

    this.subscription.add(this.commonApi.getROSolr(type, objData).subscribe(response => {      
      console.log(response);
      let resultData = [];
      if(pushFlag && response.total == 0) {
        return false;
      }
      if(this.itemOffset == 0 && searchFlag){

        let facets = (response.facets) ? response.facets : '';
        let type = (facets.type) ? facets.type : '';
        if(this.itemOffset == 0){
          switch(this.accessFrom) {
            case pageInfo.searchPage:
              setTimeout(() => {
                this.searchResultData.emit(facets);  
              }, 1500);
              break;
            case pageInfo.workstreamPage:           
                console.log(type)
                setTimeout(() => {
                  this.searchResultData.emit(type);  
                }, 1500);           
              break;   
          }
        }
      }

      /* if(this.access == 'sales' && !pushFlag && this.itemOffset == 0) {
        this.filterStatusList = [];
        this.filterAssignedTechList = [];
        this.filterBustinessList = [];
        let roStatus = filterData.workOrderStatusInfoJsonArr;
        roStatus.forEach(sitem => {
          let svalue = JSON.parse(sitem.value);
          this.filterStatusList.push({id: parseInt(svalue.id), name: svalue.statusName});
        });
        
        let assignedTech = filterData.assignTechnicanInfoJsonArr;
        assignedTech.forEach(aitem => {
          let avalue = JSON.parse(aitem.value);
          this.filterAssignedTechList.push({id: parseInt(avalue.userId), name: avalue.userName});
        });

        let businessList = filterData.roBusinessName;
        console.log(businessList)
        businessList.forEach(aitem => {
          let avalue = aitem.value;
          this.filterBustinessList.push({id: avalue, name: avalue});
        });
      } */
      console.log(this.workOrderType+'::'+this.itemTotal+'::'+response.total+' Empty Flag::'+this.itemEmpty+' No Record Flag::'+this.displayNoRecords);
      if(this.workOrderType == 'edit' || this.workOrderType == 'refresh'){
        //response = response.data;
        resultData = response.items;
      }
      else{
        //response = response.data;
        resultData = response.items;
        this.itemTotal = response.total;
        this.loading = false;
        this.listView = true;
        this.lazyLoading = this.loading;
        this.itemEmpty = (pushFlag && this.itemTotal >= 0) ? false : this.itemEmpty;
        this.displayNoRecords = (pushFlag && this.itemTotal >= 0) ? false : this.displayNoRecords;
      }



      if(this.itemOffset == 0) {
        //this.salesListColumns = response.columns;
        this.diagnationDomain = this.domainId == '338' ? true : false;
        this.cols = [];
        let shopRoClass = (this.aetoolsDomain) ? 'aet-shop-ro' : '';
        let scanColClass = (this.scanReport) ? '' : 'hide';
        if(this.access == 'sales' || this.accessFrom == pageInfo.workstreamPage || this.accessFrom == pageInfo.searchPage){
          const currentCols = []
          currentCols.push({
            "field": "id",
            "header": `Lead#`,
            "columnpclass": "header ro-thl-col-1 force-width-120 col-sticky",
            "default": true,
            "visible": true
          })
          currentCols.push(...[           
            {
                "field": "businessName",
                "header": "Customer Name",
                "columnpclass": "header ro-thl-col-2 force-width-165",
                "sortName": "businessName",
                "default": true,
                "visible": true
            },
            {
                "field": "email",
                "header": "Email",
                "columnpclass": "header ro-thl-col-5 force-width-165",
                "default": false,
                "visible": true
            },
            {
                "field": "requestTypeStr",
                "header": "Help Type",
                "columnpclass": "header ro-thl-col-5 force-width-185",
                "default": false,
                "visible": true
            },                     
            {
                "field": "requestedDate",
                "header": `Lead Date`,
                "columnpclass": "header ro-thl-col-6 force-width-170",
                "default": true,
                "visible": true
            },
            {
              "field": "assignedTechnician",
              "header": "Assignee",
              "columnpclass": "header ro-thl-col-6 force-width-140",
              "default": false,
              "visible": true
            },
            {
                "field": "createdFrom",
                "header": "Created From",
                "columnpclass": "header ro-thl-col-7 col-sticky force-width-140",
                "default": true,
                "visible": true
            },
            {
                "field": "status",
                "header": "Status",
                "columnpclass": "header ro-thl-col-7 col-sticky force-width-140",
                "default": true,
                "visible": true
            }/* ,
            {
                "field": "more",
                "header": "",
                "columnpclass": "header ro-thl-col-8"
            } */
          ]);
          if(this.completedListFlag) {
            const idx = currentCols.findIndex(col => col.field === "assignedTechnician");
            if (idx !== -1) {
              currentCols.splice(idx + 1, 0, {
                field: "completedDateTime",
                header: "Complete Date",
                columnpclass: "header ro-thl-col-6 force-width-140",
                default: false,
                visible: true
              });
            }
          }
          this.cols = currentCols;                 
        }
        this.salesListColumns = this.cols;
      }

      if(this.itemTotal>0){
        if(resultData.length>0){
          this.setupSalesData(resultData, pushFlag, updateFlag);
          if(pushFlag) {

          }
          else if(this.visibilityChangeLimit==3){
            
          }
          else{
            this.scrollCallback = true;
            this.scrollInit = 1;
            this.itemEmpty = false;
            this.displayNoRecords = false;
            this.itemLength += resultData.length;
            this.itemOffset += this.itemLimit;
          }

        }
      }
      else{
        if(!this.visibilityChange) {
          this.itemEmpty = true;
          this.displayNoRecords = true;
          this.displayNoRecordsShow = this.filterSelected ? 1 : 0;
        }
      }

      console.log(resultData);
        setTimeout(() => {
          this.visibilityChange = false;
          if (this.visibilityChangeLimit != 3 && !this.displayNoRecords && !pushFlag && this.accessLevel.view && !this.popupView) {
            let listItemHeight;
            listItemHeight = document.getElementsByClassName("parts-mat-table")[0] == undefined ? '' :
            document.getElementsByClassName("parts-mat-table")[0].clientHeight + 50;

            console.log(this.itemTotal, this.itemLength,  this.innerHeight, listItemHeight);

            if(this.itemTotal > this.itemLength && this.innerHeight >= listItemHeight) {
              this.scrollCallback = false;
              this.lazyLoading = true;
              console.log('in lazy loading')
              this.getSalesList(false);
              this.lastScrollTop = this.scrollTop;
            }
            pushFlag = false;
            this.workOrderType = '';
          }
        // pushFlag = false;
        // this.workOrderType = '';
        if(this.access == 'sales' && !pushFlag && this.itemOffset == 20 && !this.popupView) {
          this.getFilterValues();
        }
        if(this.access == 'customers' || this.accessFrom == pageInfo.workstreamPage || this.accessFrom == pageInfo.searchPage) {
          this.salesCallback.emit(this);
        }
      }, 500);
    })
    );
  }

  getSalesListItem(roId) {
    let type = 'list';
    var objData = {};    
    let FiltersArr={};
    FiltersArr["domainId"]=this.domainId;
    FiltersArr["roIdInt"]=roId;    
    objData["type"]=7;    
    objData["listing"] = 1;
    objData["filters"]=FiltersArr;
    objData["rows"]=1;
    objData["start"]=0;
    this.commonApi.getROSolr(type, objData).subscribe(response => {      
      let resultData = response.items;
      this.setupSalesData(resultData, false, true, roId);
    });
  }

  setupSalesData(items, pushFlag = false, updateFlag = false, id = 0) {
    items.forEach(item => {
      let workorder_id = item.roIdInt;
      console.log(workorder_id);
      item.id = item.roIdInt;
      item.woId = parseInt(item.id);
      if(item.createdOnStr !='0000-00-00 00:00:00'){
        let createdOn = moment.utc(item.createdOnStr).toDate();
        item.requestedDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
      }
      else{
        item.requestedDate = "-";
      }

      if(item.appointmentDateStr && item.appointmentDateStr != '' && item.appointmentDateStr != '0000-00-00 00:00:00') {
        let appointmentDate = moment(item.appointmentDateStr).format('MMM DD, YYYY');
        item.appointmentDateStr = appointmentDate;
      } else {
        item.appointmentDateStr = "-";
      }

      if(this.endUser && this.domainId == 507 && (item.workOrderStatusStr == 1 || item.workOrderStatusStr == 12 || item.workOrderStatusStr == 14)) {
        let wstatusName = '';
        switch(parseInt(item.workOrderStatusStr)) {
          case 1:
            wstatusName = 'RO Sent';
            break;
          case 12:
            wstatusName = 'Invoice';
            break;
          case 14:
            wstatusName = 'Estimate';
            break;  
        }
        item.techSupportStatusStr = wstatusName;
      }

      /* 
        Adding some variables and logics for financials list
      */
      if(item.completedDateStr && item.completedDateStr !='0000-00-00 00:00:00'){
        const completedDateTime = moment.utc(item.completedDateStr).toDate();
        item.completedDateTime = moment(completedDateTime).local().format('MMM DD, YYYY h:mm A');
      }
      else{
        item.completedDateTime = "-";
      }

      if(item.appointmentDateStr && item.appointmentDateStr != undefined){
        const aptDate = item.appointmentDateStr;
        const aptTime = (item.appointmentTimeStr && item.appointmentTimeStr != undefined) ? item.appointmentTimeStr : '00:00:00';
        const aptDateTime = `${aptDate} ${aptTime}`;
        const appointmentDateTime = moment.utc(aptDateTime).toDate();
        item.appointmentDateTime = moment(appointmentDateTime).local().format('MMM DD, YYYY h:mm A');
      }
      else{
        item.completedDateTime = "-";
      }

      let isEventTypeInt = (item?.isEventTypeInt && item.isEventTypeInt != undefined) ? item.isEventTypeInt : 1;
      
      if(isEventTypeInt == 1) {
        if(item.assignTechnicianIdInfoStr !='0'){
          try {
            item.assignedTechnician = item.assignTechnicanInfoJsonArr[0]?.firstName+ ' '+item.assignTechnicanInfoJsonArr[0]?.lastName;  
          } catch (error) {
            item.assignedTechnician = "";
          }
        }
        else{
          item.assignedTechnician = "";
        }
      }

      if(isEventTypeInt == 2) {
        if(item.assignTechnicianIdInfoStr !='0'){
          try {
            item.assignedTechnician = item.assignTechnicanInfoJsonArr[0]?.userName;
          } catch (error) {
            item.assignedTechnician = "";
          }
        }
        else{
          item.assignedTechnician = "";
        }
      }

      //calculate estimation amount for financial List
      //item.estimateInfoAmount=this.getTotalAmount(item.estimateInfoDataJsonArr);

      item.estimateInfoAmount=this.getTotalAmount(item.estimateInfoDataJsonArr);

      item.shopRo = (item.referenceShopROStr && item.referenceShopROStr != undefined) ? item.referenceShopROStr : "-";
      let make = (item.make && item.make != undefined) ? item.make : '';
      let model = (item.model && item.model != undefined) ? item.model : '';
      let year = (item.year && item.year != undefined) ? item.year : '';
      let vehicle = '-';
      if(item.threadCategoryInt == 7) {
        make = (make == 'Unknown') ? 'General Make' : make;
        model = (model == 'Unknown') ? 'General Model' : model;
        year = (year == 'Unknown') ? '' : year;
      }
      let serialNumberStr = (item.serialNumberStr && item.serialNumberStr != undefined) ? item.serialNumberStr : '';
      vehicle = (make != '') ? make : vehicle;
      vehicle = (model != '') ? `${vehicle}, ${model}` : vehicle;
      vehicle = (year != '') ? `${vehicle}, ${year}` : vehicle;
      if(item.threadCategoryInt == 10 && serialNumberStr != '' && serialNumberStr != 'undefined') {
        vehicle = `${vehicle}, ${serialNumberStr}`;
      }
      item.vehicle = vehicle;
      item.businessName = '';
      item.city = '';
      item.state = '';
      item.businessEmail = '-';

      let businessInfoJsonArr = (item.businessInfoJsonArr && item.businessInfoJsonArr != undefined) ? (item.businessInfoJsonArr) : '';
      if( businessInfoJsonArr != ''){
        let arr = businessInfoJsonArr[0];
        if(arr){
          item.businessName = arr.name != '' ? arr.name : '' ;
          item.city =  arr.city != '' ? arr.city : '' ;
          item.state =  arr.state != '' ? arr.state : '' ;
          item.businessEmail = arr.email != '' ? arr.email : '-';
        }        
      }

      item.scannedByStr = (item.scannedByStr && item.scannedByStr != undefined) ? item.scannedByStr : '-';

      let financeStatusInfoJsonArr = (item.financeStatusInfoJsonArr && item.financeStatusInfoJsonArr != undefined) ? (item.financeStatusInfoJsonArr) : '';
      item.financeStatus = item.techSupportStatusStr;
      item.financeStatusBgColor = item.techSupportStatusBgColorStr;
      item.financeStatusColor = item.techSupportStatusColorStr;
      if(financeStatusInfoJsonArr != '') {
        let finanaceStatuArr = financeStatusInfoJsonArr[0];
        item.financeStatusBgColor = finanaceStatuArr.bgColor;
        item.financeStatusColor = finanaceStatuArr.color;
        item.financeStatus = finanaceStatuArr.statusName;
      }
      let contactDetailInfoJsonArr = (item.contactDetailInfoJsonArr != null || item.contactDetailInfoJsonArr != undefined || item.contactDetailInfoJsonArr != '') ? (item.contactDetailInfoJsonArr) : '';

      this.repairOrderList.contactDetailInfo = contactDetailInfoJsonArr != '' ? contactDetailInfoJsonArr : ''
      let workOrderStatus = (this.repairOrderList.workOrderStatusStr != null || this.repairOrderList.workOrderStatusStr != undefined || this.repairOrderList.workOrderStatusStr != '') ? parseInt(this.repairOrderList.workOrderStatusStr) : 0;
      let ownerId = (this.repairOrderList.contactDetailInfo && this.repairOrderList.contactDetailInfo[0].userId) ? this.repairOrderList.contactDetailInfo[0].userId : '';
      item.deleteROAccess = !this.endUser ? true : false;
      item.editROAccess = ((this.roleId == 3 || this.userId == ownerId) || (!this.endUser && (this.domainId == 63 || this.domainId == 397 || this.domainId == 346 || this.domainId == 432 || this.domainId == 462))) ? true : false;
      item.statusAccess = (!this.endUser && (item.workOrderStatusStr == '1' || item.workOrderStatusStr == '2' || item.workOrderStatusStr == '14' || item.threadIdInt > 0) && (this.domainId == 63 || this.domainId == 397 || this.domainId == 346 || this.domainId == 432 || this.domainId == 462)) ? true : false;
      item.returnStatusAccess = (!this.endUser && ((item.workOrderStatusStr == '7' || item.workOrderStatusStr == '15') && (this.domainId == 63 || this.domainId == 397 || this.domainId == 346 || this.domainId == 432 || this.domainId == 462))) ? true : false;
      item.previousWorkOrderStatus = '';

      item.paymentMethodStr = (item.paymentMethodStr != undefined) ? item.paymentMethodStr : '-';
      item.paymentStatusStr = (item.paymentStatusStr != undefined) ? item.paymentStatusStr : '-';

      if(!this.diagnationDomain) {
        if(this.endUser) {
          item.deleteROAccess = (workOrderStatus < 3) ? true : false;
          item.editROAccess = (workOrderStatus < 3) ? true : false;
          item.statusAccess = false;
          item.returnStatusAccess = false;
        }
        if(this.deletedListFlag) {
          item.techSupportStatusBgColorStr = '#f47070';
          item.techSupportStatusStr = 'Cancel';
        }
        switch(this.domainId) {
          case 63:
          case 346:  
          case 397:
          case 432:
          case 462:  
            item.deleteROAccess = (this.roleId != 2) ? true : item.deleteROAccess;
            item.editROAccess = (this.roleId != 4) ? true : item.editROAccess;
            if(item.returnStatusAccess) {
              let prevStatus = (item.prevWorkOrderStautsInt && item.prevWorkOrderStautsInt != undefined) ? item.prevWorkOrderStautsInt : 0;
              if(prevStatus > 0) {
                let statusFlag = true;
                statusFlag = this.setupPrevStatus(prevStatus, item, statusFlag); 
                if(statusFlag) {
                  let statusName = (item.prevWorkOrderInfoJsonArr && item.prevWorkOrderInfoJsonArr != undefined && item.prevWorkOrderInfoJsonArr.length > 0) ? item.prevWorkOrderInfoJsonArr[0].statusName : 0;
                  item.previousWorkOrderStatus = statusName;
                }
              } else {
                this.setupPrevStatus(prevStatus, item, false, 1);
              }
            }
            break;    
        }
      }

      if(updateFlag) {
        let tIndex = this.repairOrderList.findIndex(option => option.id == id);
        if(tIndex != '-1'){
          this.repairOrderList[tIndex]=[];
          this.repairOrderList[tIndex]=item;
        }
        return false;
      }

      if(pushFlag) {
        if(this.workOrderType == 'edit' || this.workOrderType == 'refresh'){
          let tIndex = this.repairOrderList.findIndex(option => option.id == this.workOrderId);
          if(tIndex != '-1'){
            this.repairOrderList[tIndex]=[];
            this.repairOrderList[tIndex]=item;
          }
        }
        else{
          let tIndex = this.repairOrderList.findIndex(option => option.id == workorder_id);

          if(tIndex >= 0) 
            {
              this.repairOrderList[tIndex].techSupportStatusStr = item.techSupportStatusStr;
              this.repairOrderList[tIndex].techSupportStatusBgColorStr = item.techSupportStatusBgColorStr;
              this.repairOrderList[tIndex].techSupportStatusColorStr = item.techSupportStatusColorStr;

              this.repairOrderList[tIndex].wooStatusTextStr = item.wooStatusTextStr;
              this.repairOrderList[tIndex].wooStatusTextColorStr = item.wooStatusTextColorStr;

            }
            else
            {
              this.repairOrderList.unshift(item);
            }
          
        }
      }
      else if(this.visibilityChangeLimit==3){
        let tIndex = this.repairOrderList.findIndex(option => option.id == workorder_id);
        if(tIndex != '-1'){
          this.repairOrderList[tIndex]=[];
          this.repairOrderList[tIndex]=item;
        }  
        else
        {
          this.repairOrderList.unshift(item);
        }
      }
      else{
        let tIndex = this.repairOrderList.findIndex(option => option.id == workorder_id);
        if(tIndex >= 0) { }
        else
        {
          this.repairOrderList.push(item);
        }        
      }
    });
    this.repairOrderList = this.repairOrderList.sort((a, b) => (a.roIdInt > b.roIdInt ? -1 : 1))
    setTimeout(() => {
      if(this.access == 'customers' || this.accessFrom == pageInfo.workstreamPage || this.accessFrom == pageInfo.searchPage) {
        this.salesCallback.emit(this);
      }
    }, 500);
    console.log(this.repairOrderList)
  }

  setupPrevStatus(prevStatus, item, statusFlag, check = 0) {        
    if(item.createdOnStr && (item.createdOnStr != null || item.createdOnStr != undefined || item.createdOnStr != '' || item.createdOnStr !='0000-00-00 00:00:00')){ 
      let createdOn = moment.utc(item.createdOnStr).toDate();
      let roCreatedDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
      let currentDate = moment().local().format('MM/DD/YY HH:mm:ss');
      let checkTime = moment(currentDate).utc().diff(roCreatedDate, 'seconds');
      if(prevStatus == 1) { 
        statusFlag = false;
        if(checkTime >= 1800) {
          item.prevWorkOrderStautsInt = 2;
          item.previousWorkOrderStatus = 'Pending';
        } else {
          item.prevWorkOrderStautsInt = 1;
          let status = (this.endUser && this.domainId == 507) ? 'RO Sent' : 'New'; 
          item.previousWorkOrderStatus = status;
        }
      } else {
        if(this.endUser) {
          let status = '';
          switch(prevStatus) {
            case 12:
              status = 'Invoice';
              break;
            case 14:
              status = 'Estimate';
              break;              
          }
          item.previousWorkOrderStatus = status;
        }
      }
    }
    return statusFlag;
  }

  openDetailView(id){
    
  }

  // Nav Part Edit or View
  navPart(action, id, i) {
    let url;
    switch (action) {
      case "view":
        url = `${this.redirectUrl}/${id}`;
        break
      default:
        break;
    }
    //console.log(url)
    setTimeout(() => {
      let teamSystem = localStorage.getItem("teamSystem");
      if (teamSystem) {
        window.open(url, IsOpenNewTab.teamOpenNewTab);
      } else {
        // window.open(url, IsOpenNewTab.openNewTab);
        window.open(url, url);
      }
      //window.open(url, '_blank');
    }, 50);
  }

  // Set Screen Height
  setScreenHeight() {
    let customerAccess = (this.access == 'customers') ? true : false;
    this.innerHeight = 0;
    this.emptyHeight = 0;
    let headerHeight3 = 0;
    let headerHeight =  (document.getElementsByClassName("prob-header")[0]) ? document.getElementsByClassName("prob-header")[0].clientHeight : 0;
    let headerHeight1 = (document.getElementsByClassName("head-brand")[0]) ? document.getElementsByClassName("head-brand")[0].clientHeight : 0;
    
    headerHeight3 = headerHeight + headerHeight1;
    let auditHeader = (customerAccess && document.getElementsByClassName("audit-header")[0]) ? document.getElementsByClassName("audit-header")[0].clientHeight : 0;
    let rmHeight = 0;  
    this.tableRemoveHeight = 0; 
    
    if(this.accessFrom == pageInfo.workstreamPage){
      rmHeight = (customerAccess) ? 35 : 140; 
      this.tableRemoveHeight = (customerAccess) ? 175 : 130 + headerHeight3;
    }
    else if(this.accessFrom == pageInfo.searchPage){
      rmHeight = (customerAccess) ? 35 : 140; 
      this.tableRemoveHeight = (customerAccess) ? 175 : 140 + headerHeight3;
    }
    else if(this.access == 'financials-list'){
      rmHeight = 70; 
      this.tableRemoveHeight = (customerAccess) ? 175 : 140 + headerHeight3;
    }
    else{
      rmHeight = (customerAccess) ? 50: 90; 
      this.tableRemoveHeight = (customerAccess) ? 90 + auditHeader + headerHeight3 : 120 + headerHeight3;
    }

    this.innerHeight = this.bodyHeight - (headerHeight3 + auditHeader + rmHeight);
    this.emptyHeight = this.bodyHeight - (headerHeight3 + auditHeader + rmHeight);    
  }

  // Onscroll
  scroll = (event: any): void => {
    if(event.target.id=='partList' || event.target.className=='p-datatable-scrollable-body ng-star-inserted') {
      let inHeight = event.target.offsetHeight + event.target.scrollTop;
      let totalHeight = event.target.scrollHeight - this.itemOffset - 80;
      this.scrollTop = event.target.scrollTop - 80;
      if (this.scrollTop > this.lastScrollTop && this.scrollInit > 0) {
        if(inHeight >= totalHeight && this.scrollCallback && this.itemTotal > this.itemLength) {
          this.lazyLoading = true;
          this.scrollCallback = false;
          this.visibilityChangeLimit = 0;
          this.getSalesList(false);
        }
      }
      this.lastScrollTop = this.scrollTop;
    }
  }

  // New Navigation
  pageNav() {
    let url = `${this.pageUrl}`;
    window.open(url, url);
  }

  openRepairOrderPOPUP(type,id){

  }

  navPage(page, id) {
    let url;
    let navigation = true;
    switch (page) {
      case 'threads':
        let viewPath = (this.collabticDomain && this.domainId == 336) ? 'view-v3' : 'view-v2';
        url = `${RedirectionPage.Threads}/${viewPath}/${id}`;
        break;
      case 'dispatch':
        navigation = false;
        url = `${RedirectionPage.Dispatch}/${id}`;
        let navDispatch = window.open(url, url);
        navDispatch.focus();
        break;  
    }
    if(navigation) {
      localStorage.setItem("prevNavURL",this.router.url);
      this.router.navigate([url]);
    }
  }

  deleteConfirmRepairOrderModal(id){
    const modalRef = this.modalService.open(ConfirmationComponent, this.modalConfig);
    modalRef.componentInstance.access = 'DeleteRO';
    modalRef.componentInstance.title = `Delete ${this.shortTitle}`;
    modalRef.componentInstance.confirmAction.subscribe((receivedService) => {
      modalRef.dismiss('Cross click');
      console.log(receivedService);
      if(receivedService){
        this.deleteRepairOrderModal(id);
      }
    });    
  }

  deleteRepairOrderModal(id){
    this.bodyElem.classList.add(this.bodyClass2);
    const modalRef = this.modalService.open(
      SubmitLoaderComponent,
      this.modalConfig
    );

    let formData = new FormData();
    formData.append('apiKey', Constant.ApiKey);
    formData.append('domainId', this.domainId);
    formData.append('userId', this.userId);
    formData.append('workOrderId', id);
    this.repairOrderApi.deleteSupportTicketsList(formData).subscribe(response => {
      console.log(response);
      
      modalRef.dismiss("Cross click");
      this.bodyElem.classList.remove(this.bodyClass2);

      if (response.status == "Success") {

        this.successMsg = response.message;

          const msgModalRef = this.modalService.open(
            SuccessModalComponent,
            this.modalConfig
          );
          msgModalRef.componentInstance.successMessage = this.successMsg;

          let threadIndex = this.repairOrderList.findIndex(option => option.id == id);
          let dispatchId = this.repairOrderList[threadIndex].dispatchIdInt;
          if(dispatchId > 0) {
            //this.changeDispatchStatus(dispatchId, 5);
          }
          this.repairOrderList.splice(threadIndex, 1);
          this.itemTotal -= 1;
          this.itemLength -= 1;
          if(this.repairOrderList.length==0){
            this.itemOffset = 0;
            setTimeout(() => {
              this.getSalesList(false);  
            }, 500);            
          }

          let apiDatasocial = new FormData();
          apiDatasocial.append('apiKey', Constant.ApiKey);
          apiDatasocial.append('domainId', this.domainId);
          apiDatasocial.append('workOrderId', id);
          //apiDatasocial.append('threadId', threadId);
          //apiDatasocial.append('postId', postId);
          apiDatasocial.append('userId', this.userId);
          apiDatasocial.append('action', 'delete');             
          apiDatasocial.append('actionType', '7');
          this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { });

          setTimeout(() => {
            msgModalRef.dismiss("Cross click");
            this.successMsg = "";
          }, 2000);
      }
    });
  }

  checkAccessLevel(){
    let viewAccess = true, createAccess = true, editAccess = true,  deleteAccess = true;
    let chkType = '', chkFlag = true;
    localStorage.removeItem('checkAccess');
    this.authenticationService.checkAccess(this.contentType, chkType, chkFlag);
    this.setInterval = setInterval(()=>{                
      let checkAccess = localStorage.getItem('checkAccess');  
      if(checkAccess == '1') { 
        let accessLevels = this.authenticationService.checkAccessItems;
        if(accessLevels && accessLevels.length > 0) {
          let reportAccess = accessLevels[0].pageAccess;
          reportAccess.forEach(item => {
            let accessId = parseInt(item.id);
            let roles = item.roles;
            let roleIndex = roles.findIndex(option => option.id == this.roleId);
            if(roleIndex < 0) {
              return false;
            }
            let roleAccess = (roles[roleIndex].access && roles[roleIndex].access != undefined) ? roles[roleIndex].access : 0;
            console.log(accessId, roleAccess)
            switch (accessId) {
              case 1:
                viewAccess = (roleAccess == 1) ? true : false;
                break;
              case 2:
                createAccess = (roleAccess == 1) ? true : false;
                break;
              case 3:
                editAccess = (roleAccess == 1) ? true : false;
                this.editRO = editAccess;
                break;
              case 4:
                deleteAccess = (roleAccess == 1) ? true : false;
                break;
            }
          });

        }        
        let defaultAccessLevel : any = {view: viewAccess, create: createAccess, edit: editAccess, delete:deleteAccess};   
        if(this.apiUrl.enableAccessLevel){
          this.accessLevel =  defaultAccessLevel.create != undefined ?  defaultAccessLevel : this.accessLevel;
        }
        else{
          this.accessLevel = defaultAccessLevel.create != undefined ?  defaultAccessLevel : this.accessLevel;
        }        
        console.log(this.accessLevel)
        clearInterval(this.setInterval);
        localStorage.removeItem('checkAccess');
      }
    },50);
  }

  getTotalAmount(estimateInfoDataJsonArr){
    let totalAmount=0;
    if(estimateInfoDataJsonArr && estimateInfoDataJsonArr.length){
      estimateInfoDataJsonArr.forEach((estElement) => {
        if(estElement && estElement.estimateData && estElement.estimateData.length){
          estElement.estimateData.forEach((element) => {
            totalAmount+=Number(element.jobtotal || 0)
          });
        }
      });
    }
    return totalAmount;
  }

  manageAction(action, roList) {

  }

  reopenThread(threadId) {
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('countryId', this.countryId);
    apiFormData.append('userId', this.userId);
    apiFormData.append('threadId', threadId);
    apiFormData.append('notify', '0');
    apiFormData.append('platform', '3');
    this.threadPostService.reopenThread(apiFormData).subscribe(res => {
      let taction = 'update';
      let tactionType = SolrContentTypeValues.Thread;
      this.updateSolr(taction, tactionType, threadId);
    });
  }

  changeDispatchStatus(dispatchId, statusId) {
    const apiInfo = {
      apikey: Constant.ApiKey,
      countryId: this.countryId,
      domainId: this.domainId,
      userId: this.userId,
      action: 'change',
      serviceId: dispatchId,
      statusId,
      fieldId: statusId,
      field:'status',
      platform: '3'
    };
    this.LandingpagewidgetsAPI.manageServiceAPI(apiInfo).subscribe(response => {});
  }

  closeThread(threadId) {
    let capiData = new FormData();
    capiData.append('apiKey', Constant.ApiKey);
    capiData.append('domainId', this.domainId);
    capiData.append('countryId', this.countryId);
    capiData.append('userId', this.userId);
    capiData.append('threadId', threadId);
    capiData.append('closeStatus', 'yes');
    capiData.append('emailFlag', '1');
    capiData.append('platform', '3');
    this.threadPostService.closeThread(capiData).subscribe(response => {
      let taction = 'update';
      let tactionType = SolrContentTypeValues.Thread;
      this.updateSolr(taction, tactionType, threadId);
    });
  }

  threadSilentPush(threadId) {
    let apiData = new FormData();
    apiData.append('apiKey', Constant.ApiKey);
    apiData.append('domainId', this.domainId);
    apiData.append('userId', this.userId);
    apiData.append('threadId', threadId);
    apiData.append('silentPush', '1');
    apiData.append('action', 'close'); 
    this.threadPostService.sendPushtoMobileAPI(apiData).subscribe((response) => {});
  }

  changeRoStatus(roId, statusId) {
    let platform: any = 3;
    let apiDatasocial = new FormData();
    apiDatasocial.append('apiKey', Constant.ApiKey);
    apiDatasocial.append('domainId', this.domainId);               
    apiDatasocial.append('userId', this.userId);
    apiDatasocial.append('id', roId);          
    apiDatasocial.append('statusId', statusId);
    apiDatasocial.append('platform', platform);
    this.repairOrderApi.changeStatusTicket(apiDatasocial).subscribe(res => {
      let action = 'update';
      let actionType = SolrContentTypeValues.repairOrder;
      this.successMsg = `${this.shortTitle} Status Updated.`;
      const msgModalRef = this.modalService.open(
        SuccessModalComponent,
        this.modalConfig
      );
      msgModalRef.componentInstance.successMessage = this.successMsg;
      this.updateSolr(action, actionType, roId);
      setTimeout(() => {
        let roIndex = this.repairOrderList.findIndex(option => option.id == roId);
        if(roIndex >= 0) {
          let completedRo = this.repairOrderList[roIndex].completeStatusInt;
          let removeFlag = false;
          let apiCall = true;
          switch(completedRo) {
            case 0:
              switch(statusId) {
                case 7:
                case 12:
                case 13:
                  removeFlag = true;
                  break;
              }
              break;
            case 1:
              switch(statusId) {
                case 1:
                case 2:
                case 13:
                case 14:
                  removeFlag = true;
                  break;
              }
              break;  
          }
          if(removeFlag) {
            apiCall = false;
            this.repairOrderList.splice(roIndex, 1);
          }
          if(apiCall) {
            setTimeout(() => {
              this.getSalesListItem(roId);
            }, 500);
          }
        }        
        this.itemTotal -= 1;
        this.itemLength -= 1;
        if(this.repairOrderList.length==0){
          this.itemOffset = 0;
          setTimeout(() => {
            this.getSalesList(false);  
          }, 500);            
        }
        msgModalRef.dismiss("Cross click");
        this.successMsg = "";
      }, 2000);
    });
  }

  updateSolr(action, actionType, dataId) {
    let apiDatasocial = new FormData();
    apiDatasocial.append('apiKey', Constant.ApiKey);
    apiDatasocial.append('domainId', this.domainId);
    apiDatasocial.append('userId', this.userId);
    apiDatasocial.append('action', action);
    apiDatasocial.append('actionType', actionType);
    switch (actionType) {
      case 1:
        apiDatasocial.append('threadId', dataId);
        break;
      case 7:
        apiDatasocial.append('workOrderId', dataId);
        break;
    }
    this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { });
  }

  downloadReport() {
    if(this.itemTotal>0){
      let objData = {
        exactMatch: false,
        type: SolrContentTypeValues.repairOrder,
        listing: 1,
        userId: this.userId,
        shortTitle: this.shortTitle
      };
      this.saveObjData["rows"]=this.itemTotal;
      let currDateTime = moment().format('YYYY_MM_DD_hh_mm_A');
      const modalRef = this.modalService.open(ExportPopupComponent,  {backdrop: 'static', keyboard: false, centered: true});
      modalRef.componentInstance.apiData = objData;
      modalRef.componentInstance.title = `${this.shortTitle} Report`;
      modalRef.componentInstance.exportInfo = '';
      modalRef.componentInstance.exportData = '';
      modalRef.componentInstance.access = "ro-report-filter";
      modalRef.componentInstance.exportAllFlag = false;
      modalRef.componentInstance.scanReportFlag = this.scanReport;
      modalRef.componentInstance.currDateTime = currDateTime;
      modalRef.componentInstance.serviceRecordObjData = this.saveObjData;
      modalRef.componentInstance.serviceRecordType = this.saveObjData.query &&  this.saveObjData.query != '' ? 'search' : 'list';
      modalRef.componentInstance.updateonExportisDone.subscribe((receivedService) => {
        if (receivedService == 1) {
          modalRef.dismiss('Cross click');
        }
        //this.api.exportAction = '1';
      });
    }
  }

  gotoCustomerPage(id){
    let navFlag: any = 1;
    localStorage.setItem('navFromDianationThread', navFlag);
    localStorage.removeItem('customerBackAction');
    
    let backPageFlag: any = 1; 
    localStorage.setItem('backPageActionName', 'financials');
    localStorage.setItem('backPageFlag', backPageFlag);
    localStorage.setItem('backPageURL', "/financials/repair-order");

    let url = `${RedirectionPage.Customers}/${id}`;
    this.router.navigate([url]);      
  }

  getFormattedCityState(city: any, state: any){
    if(city && state) return city + ", "+ state
    if(city) return city
    if(state) return state
    return "-"
  }

  checkVisibleColumn(field) {
    let visibleFlag = true;
    let columns = this.salesListColumns;
    let colIndex = columns.findIndex(c => c.field === field);
    if(colIndex >= 0) {
      visibleFlag = columns[colIndex].visible;
    }
    return visibleFlag;
  }

  assignTech(item) {
    console.log('RO Item:', item);
    const apiData = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      userId: this.userId,
      countryId: this.countryId,
      networkId: this.user.networkId        
    };

    const modalRef = this.modalService.open(AssignedTechComponent, {
        backdrop: "static",
        keyboard: false,
        centered: true,
        size: "xl",
        windowClass: 'jobs-popup-custom-model assign-tech-custom-model'
    });

    const iHeight = window.innerHeight
    modalRef.componentInstance.type = 'assign';
    modalRef.componentInstance.apiData = apiData;
    modalRef.componentInstance.height = iHeight - 130;
    modalRef.componentInstance.selectType = "single";
    modalRef.componentInstance.title = `Assignee - Lead# ${item.roIdInt}`;
    modalRef.componentInstance.defaultType = 1;
    modalRef.componentInstance.defaultSelectedId = parseInt(item.assignTechnicianIdInfoStr);
    modalRef.componentInstance.selectedItems.subscribe((receivedService) => {
      console.log("Received ", receivedService);
      let assignType = receivedService.assignType;
      let techId = [receivedService.techId];
      let id = item.id;
      let apiData = {
        apikey: Constant.ApiKey,
        domainId: this.domainId,
        userId: this.userId,
        id,
        techId: JSON.stringify(techId),
        assignType
      }
      this.LandingpagewidgetsAPI.apiAssignTech(apiData).subscribe((apiResponse) => {
        this.workOrderType = 'refresh';
        this.workOrderId = id;
        setTimeout(() => {
          this.getSalesList(true);  
        }, 1500);
      });
    }); 
  }

  ngOnDestroy() {
    this.pushRoArrayNotification=[];
    this.subscription.unsubscribe();
    this.bodyElem.classList.remove("repairorderlist");
  }

}
